import { render, staticRenderFns } from "./ManageRoleAdd.vue?vue&type=template&id=30a91e34"
import script from "./ManageRoleAdd.vue?vue&type=script&lang=js"
export * from "./ManageRoleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports